import clsx from 'clsx'
import React from 'react'
import Loader from "react-loader-spinner";

const Button = ({ loading, className, disabled, children, kind = 'primary', ...rest }) => {
  let buttonClassName = clsx("w-72 h-12 mx-auto capitalize text-white bg-red-tertiary focus:ring-0 rounded-full text-lg px-5 py-2.5 me-2 mb-2 focus:outline-none font-bold", disabled && 'opacity-60', !disabled && 'hover:bg-red-500', className)

  if (kind === 'secondary') {
    buttonClassName = clsx("w-72 h-12 mx-auto capitalize text-red-tertiary bg-blue-tertiary focus:ring-0 rounded-full text-lg px-5 py-2.5 me-2 mb-2 focus:outline-none font-bold", disabled && 'opacity-60', !disabled && 'hover:bg-blue-quaternary', className)
  }

  return (
    <button
      type="button"
      disabled={disabled}
      {...rest}
      className={buttonClassName}
    >
      {loading ? (
        <Loader
          type="Oval"
          visible={true}
          color="#7CEDFE"
          width={24}
          height={24}
          className="flex flex-1 justify-center items-center"
        />
      ) : children}
    </button>
  )
}

export default Button
